import { colours } from "@shared/ui.design-system";
import { CloseIcon, TickIcon } from "@shared/ui.icons";
import { MarkdownContainer, Typography } from "@shared/ui.primitives";
import React from "react";

import {
  conIcon,
  container,
  header,
  itemRow,
  proIcon,
  section
} from "./ProsAndConsList.css";

export interface ProsAndConsListProps {
  heading: string;
  pros?: string[];
  cons?: string[];
}

export const ProsAndConsList: React.FC<ProsAndConsListProps> = ({
  heading,
  pros = [],
  cons = []
}) => {
  return (
    <div className={container} data-testid="pros-cons-list">
      <div className={header}>
        <MarkdownContainer
          content={heading}
          tagOverrides={{
            p: {
              component: Typography,
              props: {
                as: "p",
                variant: "subheader-6",
                colour: "primary-dark"
              }
            }
          }}
        />
      </div>

      {pros.length ? (
        <div className={section}>
          {pros.map((pro, idx) => (
            <div className={itemRow} key={`pro-${idx}`}>
              <span className={proIcon}>
                <TickIcon
                  fill={colours.secondary.light}
                  width={12}
                  height={12}
                />
              </span>
              <MarkdownContainer
                content={pro}
                tagOverrides={{
                  p: {
                    component: Typography,
                    props: {
                      as: "p",
                      variant: "body-sm",
                      colour: "primary-dark"
                    }
                  }
                }}
              />
            </div>
          ))}
        </div>
      ) : null}
      {cons.length ? (
        <div className={section}>
          {cons.map((con, idx) => (
            <div className={itemRow} key={`con-${idx}`}>
              <span className={conIcon}>
                <CloseIcon
                  fill={colours.secondary.light}
                  width={12}
                  height={12}
                />
              </span>
              <MarkdownContainer
                content={con}
                tagOverrides={{
                  p: {
                    component: Typography,
                    props: {
                      as: "p",
                      variant: "body-sm",
                      colour: "primary-dark"
                    }
                  }
                }}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
